'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamor = require('glamor');

var _join = require('lodash/join');

var _join2 = _interopRequireDefault(_join);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ------------------------------------------------------------------------------
// ----------------------------------------------------------------------- Styles
// ------------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Presets
// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Imports
// ----------------------------------------------------------------------------
var presets = {
  default: ['#EE7752', '#E73C7E', '#23A6D5', '#23D5AB'],
  cyberPunk: ['#00ff9f', '#00b8ff', '#001eff', '#bd00ff', '#d600ff'],
  life: ['#F9ED69', '#F08A5D', '#B83B5E', '#6A2C70'],
  blue: ['#48466D', '#3D84A8', '#46CDCF', '#ABEDD8'],
  gray: ['#FAFAFA', '#F2F2F2', '#EAEAEA', '#969696'],
  grey: ['#FAFAFA', '#F2F2F2', '#EAEAEA', '#969696'],
  earth: ['#EDDE91', '#D99751', '#E1B07B', '#8D5B32', '#6A4128']

  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Animated Gradient
};var keyframes = _glamor.css.keyframes({
  '0%': { backgroundPosition: '0% 50%' },
  '50%': { backgroundPosition: '100% 50%' },
  '100%': { backgroundPosition: '0% 50%' }
});
var keyframesName = keyframes.toString();

var animatedGradient = (0, _glamor.css)({
  WebkitAnimation: keyframesName + ' 3s ease infinite',
  MozAnimation: keyframesName + ' 3s ease infinite',
  animation: keyframesName + ' 3s ease infinite',
  width: 'inherit',
  height: 'inherit'
});
var animatedGradientClass = animatedGradient.toString();

// ------------------------------------------------------------------------------
// -------------------------------------------------------------------- Component
// ------------------------------------------------------------------------------
/**
 * AnimatedGradient
 */
var AnimatedGradient = function AnimatedGradient(props) {
  return _react2.default.createElement('div', {
    className: animatedGradientClass,
    style: {
      background: 'linear-gradient(-45deg, ' + (0, _join2.default)(presets[props.preset], ', ') + ')',
      backgroundSize: '600% 600%',
      WebkitAnimationDuration: Math.floor(Math.random() * 500 + 1) * 4 + 1500 + 'ms',
      MozAnimationDuration: Math.floor(Math.random() * 500 + 1) * 4 + 1500 + 'ms',
      AnimationDuration: Math.floor(Math.random() * 500 + 1) * 4 + 1500 + 'ms'
    }
  });
};

// ------------------------------------------------------------------------------
// ------------------------------------------------------------------------Typing
// ------------------------------------------------------------------------------
AnimatedGradient.propTypes = process.env.NODE_ENV !== "production" ? {
  preset: _propTypes2.default.string,
  classes: _propTypes2.default.object // eslint-disable-line
} : {};

AnimatedGradient.defaultProps = {
  preset: 'default'

  // ----------------------------------------------------------------------- Export
};exports.default = AnimatedGradient;
module.exports = exports['default'];